import type { WebConfig } from '@tencent/aegis-web-sdk-v2';
import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { AEGIS_IGNORE_MESSAGES, AEGIS_IGNORE_REGEXPS } from 'common/constants/Constants';
import JSRuntime from './JSRuntime';

/**
 * 获取 aegis 环境
 * @returns aegis 环境
 */
const getAegisEnv = () => {
  if (JSRuntime.isProduction) {
    return AegisV2.environment.PROD;
  }
  if (JSRuntime.isPre) {
    return AegisV2.environment.PRE;
  }
  if (JSRuntime.isTest) {
    return AegisV2.environment.TEST;
  }
  return AegisV2.environment.DEV;
};

/**
 * 默认白屏插件配置
 */
export const defaultWhiteBlankConfig = {
  containers: ['#root'],
  ignoreContainers: ['blank-page'],
  detectStartPosition: {
    x: 0,
    y: 0,
  },
  emptyElementsPercent: 90,
  sameElementsPercent: 90,
  debounceDuration: 1500,
  everySideSampleNumber: 9,
  disableSameElementsCheck: false,
  ignoreElesWhenDomChange: [],
  reDetectInterval: 4500,
  samePointDepth: 5,
};

/**
 * aegis 默认配置
 */
export const defaultConfig: WebConfig = {
  hostUrl: {
    url: JSRuntime.isIntl
      ? 'https://tgalileo.com/collect'
      : 'https://galileotelemetry.tencent.com/collect',
  },
  env: getAegisEnv(),
  repeat: 0,
  compress: true,
  plugin: {
    spa: true,
    apiSpeed: true,
    assetSpeed: true,
    session: true,
    blankScreen: defaultWhiteBlankConfig,
    pagePerformance: { longtask: true },
  },
};

/**
 * 处理上报数据
 * @param pageDomains 页面域名
 */
export const handleBeforeSend = (pageDomains: string[]) => {
  return (logs: any, aegisInfo: any = {}) => {
    // 页面来源非本项目使用的域名 || chrome87 不上报
    if (
      !pageDomains.some((domain) => String(aegisInfo.snapshootInfo?.from).startsWith(domain)) ||
      navigator.userAgent.includes('Chrome/87.0.4280')
    ) {
      return [];
    }
    return logs.filter((log: any) => {
      const { type = '', msg = '', level = '' } = log;

      // 忽略不需要上报的错误日志
      if (
        AEGIS_IGNORE_MESSAGES.some((ignoreMsg) => msg.includes(ignoreMsg)) ||
        AEGIS_IGNORE_REGEXPS.some((msgRegExp) => msgRegExp.test(msg))
      ) {
        return false;
      }

      if (type === 'normal') {
        // 文件加载错误（js、css、图片、媒体）
        if (
          level === 'script_error' ||
          level === 'image_error' ||
          level === 'css_error' ||
          level === 'media_error'
        ) {
          return pageDomains.some((domain) => msg.includes(domain));
        }
      }

      return true;
    });
  };
};
